
import {createSlice} from "@reduxjs/toolkit";

export const dataPointAttributeSlice = createSlice({
    name: 'dataPointAttributeSlc',
    initialState: {value: {id: null, mcode: null, name: null, description: null,
            status: null,category: null,
            dpaDrawerState: false, dpaDrawerMode: null, dpaGridRefresh: false
        }},
    reducers:

{
    changeDataPointAttribute: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeDataPointAttribute } = dataPointAttributeSlice.actions;

export default  dataPointAttributeSlice.reducer ;
